module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_002_small.0fd4a7c8.jpg";